/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, Component} from '@angular/core';

import {ApiService} from '../../api/api.service';
import {Image} from '../../files';
import {Headers} from '../../utils/headers';
import {isPresent} from '../../utils/lang';

import {AbstractField} from './abstract-field';

/**
 * An input type text on one line type of field
 */
@Component({
  selector: 'gp-form-field-photo',
  template: `
    <!--
        <gp-image-picker
          [placeholder]="value?.value?.current"
          [(ngModel)]="image" [formControl]="control"></gp-image-picker>
          -->
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhotoFieldComponent extends AbstractField {
  public image: Image;

  constructor(private api: ApiService) {
    super();
  }

  public dataURItoBlob(dataURI: any): Blob {
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {type: 'image/png'});
  }

  public cancel() {
    this.image = undefined;
  }

  public upload() {
    if (!isPresent(this.value)) {
      console.error('Cannot upload photo : no URL was provided');
    }

    this.api.uploadFile(this.value.value.update, this.dataURItoBlob(this.image.file), {
      additionalData: {
        width: this.image.dimensions.width,
        height: this.image.dimensions.height
      },
      fileName: this.image.fileName
    }).subscribe(response => {
      if (response.status === 201) {
        // Get new image location.
        // FIXME : here we remote the first path element ('/rest-api/') as it's sent duplicated by the server.
        // Remove this when REST API is fixed.
        const location = Headers.get(response.headers, 'Location');
        const parser = document.createElement('a');
        parser.href = location;

        this.value.value.current = parser.pathname.split('/').filter((element, index) => index > 1).join('/');
      } else {
        console.warn('Failed to upload photo : Invalid response code', response);
      }
    }, error => {
      console.error('Failed to upload photo', error);
    });
  }

  public initialize() {
    this.control.valueChanges.subscribe(newValue => {
      if (newValue !== undefined) {
        this.upload();
      }
    });
  }
}
